import { SearchStore } from '../../../store/search/SearchStore'
import { PartsCatalog } from '../../../store/partsCatalog/PartsCatalog'
import { CatalogNode } from '../../../store/partsCatalog/CatalogNode'

export const breadCrumbsSelection = (
  searchStore: SearchStore,
  partsCatalog: PartsCatalog,
  searchByFunction: (number) => void
): void => {
  const { handleAddBreadCrumb, buildBreadCrumbText } = searchStore

  const categoryGroupsFiltered = []

  const selectedPartTypes = partsCatalog?.searchedPartTypes?.filter(
    (item) => item.isSelected
  )

  if (selectedPartTypes.length > 0) {
    selectedPartTypes.forEach((item) => categoryGroupsFiltered.push(item))
  }

  if (partsCatalog?.categoryGroups()?.length > 0) {
    partsCatalog?.categoryGroups()?.forEach((group) => {
      group
        .getChildren()
        .forEach((item) =>
          item.selected ? categoryGroupsFiltered.push(item) : null
        )
    })
  }

  const partTypeNames =
    categoryGroupsFiltered?.map((g: CatalogNode) => g.value) ?? []

  const breadCrumText = buildBreadCrumbText(partTypeNames, 2)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Bulk disabling. Fix if possible.
  const newBreadCrumb: any = {
    page: 'partsCatalog',
    breadcumb: breadCrumText,
    url: searchByFunction,
  }
  handleAddBreadCrumb(newBreadCrumb)
}
